import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { BaseView, BaseText } from '@/components/base'
import { AppButton, StickyHeaderNavigation, SelectCardItem } from '@/components'
import { availableLanguages } from '@/constants/availableLanguages'
import { useAppPreferencesStore } from '@/store/useAppPreferencesStore'

export const ChooseLanguageScreen: React.FC = () => {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()

  const languageOnPreferences = useAppPreferencesStore((s) => s.language)
  const setAppPreferences = useAppPreferencesStore((s) => s.setAppPreferences)

  const [language, setLanguage] = useState(languageOnPreferences)

  const sortedLanguages = [...availableLanguages].sort((a, b) => {
    if (a.language_key === languageOnPreferences) return -1
    if (b.language_key === languageOnPreferences) return 1
    return 0
  })

  const handleSaveNewLanguage = async () => {
    if (language) {
      // Update language in store
      setAppPreferences({ language })

      // Update i18n
      let lng: string = 'en-US'
      if (language === 'pt') lng = 'pt-BR'
      if (language === 'en') lng = 'en-US'
      if (language === 'ar') lng = 'ar-KW'
      if (language === 'ru') lng = 'ru-RU'

      await i18n.changeLanguage(lng)

      // AWAIT SET NEW LANGUAGE
      setTimeout(() => {
        // Navigate back to profile settings, replacing current history entry
        navigate('/profile/profile-settings', { replace: true })
      }, 100)
    }
  }

  return (
    <BaseView flex={1} bgColor="background.screen" className="h-full">
      {/* Fixed Header Navigation */}
      <StickyHeaderNavigation
        title={t('screens:profile.profileSettings.items.language.title')}
      />

      {/* Scrollable Content */}
      <BaseView
        flex={1}
        px={12}
        style={{
          overflowY: 'auto',
          paddingBottom: '140px', // Space for save button
        }}
      >
        <BaseView mt={16} flex={1} gap={20}>
          <BaseText fontSize={28} fontFamily="semibold" color="label.default">
            {t('translation:whichLanguageDoYouPrefer')}
          </BaseText>

          <BaseView gap={8}>
            {sortedLanguages.map(({ language_key, name, code, imagePath }) => {
              const isSelected = language === language_key

              return (
                <SelectCardItem
                  key={language_key}
                  isSelected={isSelected}
                  title={name}
                  description={code || ''}
                  imagePath={imagePath}
                  onPress={() => setLanguage(language_key)}
                />
              )
            })}
          </BaseView>
        </BaseView>
      </BaseView>

      {/* Fixed Save Button */}
      <BaseView
        px={12}
        py={24}
        bgColor="background.screen"
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
        }}
      >
        <AppButton
          label={t('form:actions.save')}
          disabled={language === languageOnPreferences}
          onClick={handleSaveNewLanguage}
        />
      </BaseView>
    </BaseView>
  )
}
